"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledSystem = require("styled-system");

var _propTypes2 = _interopRequireDefault(require("@styled-system/prop-types"));

var _color = _interopRequireDefault(require("../../style/utils/color"));

var _base = _interopRequireDefault(require("../../style/themes/base"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const getAs = variant => {
  switch (variant) {
    case "h1-large":
      return "h1";

    case "segment-header":
    case "segment-header-small":
    case "segment-subheader":
    case "segment-subheader-alt":
      return "h5";

    case "big":
      return "p";

    default:
      return variant;
  }
};

const getSize = variant => {
  switch (variant) {
    case "h1-large":
      return "32px";

    case "h1":
      return "24px";

    case "h2":
      return "22px";

    case "h3":
    case "segment-header":
      return "20px";

    case "h4":
    case "segment-header-small":
      return "18px";

    case "h5":
    case "segment-subheader":
    case "big":
      return "16px";

    case "small":
    case "sub":
    case "sup":
      return "13px";

    case "segment-subheader-alt":
    case "p":
    case "b":
    case "strong":
    case "em":
    default:
      return "14px";
  }
};

const getLineHeight = variant => {
  switch (variant) {
    case "h1-large":
      return "40px";

    case "h1":
    case "segment-subheader":
      return "31px";

    case "h2":
      return "29px";

    case "h3":
    case "segment-header":
      return "26px";

    case "big":
      return "24px";

    case "h4":
    case "segment-header-small":
      return "23px";

    case "small":
    case "sub":
    case "sup":
      return "20px";

    case "h5":
    case "segment-subheader-alt":
    case "p":
    case "b":
    case "strong":
    case "em":
    default:
      return "21px";
  }
};

const getWeight = variant => {
  switch (variant) {
    case "h1-large":
    case "h1":
    case "segment-header":
    case "segment-header-small":
    case "strong":
      return "900";

    case "h2":
    case "h3":
    case "segment-subheader":
    case "segment-subheader-alt":
    case "b":
    case "em":
      return "700";

    case "h4":
    case "h5":
    case "p":
    case "small":
    case "big":
    case "sub":
    case "sup":
    default:
      return "400";
  }
};

const getTransform = variant => {
  if (variant === "segment-subheader-alt") {
    return "uppercase";
  }

  return "none";
};

const getDecoration = variant => {
  if (variant === "em") {
    return "underline";
  }

  return "none";
};

const Typography = _styledComponents.default.span.attrs(({
  variant,
  as,
  fontSize,
  fontWeight,
  textTransform,
  lineHeight,
  textDecoration
}) => {
  return {
    as: as || getAs(variant),
    size: fontSize || getSize(variant),
    weight: fontWeight || getWeight(variant),
    textTransform: textTransform || getTransform(variant),
    textDecoration: textDecoration || getDecoration(variant),
    lineHeight: lineHeight || getLineHeight(variant),
    defaultMargin: variant === "p" ? "0 0 16px" : "0"
  };
})`
  ${({
  size,
  weight,
  textTransform,
  lineHeight,
  defaultMargin,
  textDecoration,
  display,
  variant,
  listStyleType,
  whiteSpace,
  wordWrap,
  textOverflow,
  truncate
}) => (0, _styledComponents.css)`
    font-style: normal;
    font-size: ${size};
    font-weight: ${weight};
    text-transform: ${textTransform};
    text-decoration: ${textDecoration};
    line-height: ${lineHeight};
    margin: ${defaultMargin};
    padding: 0;
    white-space: ${truncate ? "nowrap" : whiteSpace};
    word-wrap: ${wordWrap};
    text-overflow: ${truncate ? "ellipsis" : textOverflow};
    ${truncate && (0, _styledComponents.css)`
      overflow: hidden;
    `};
    ${variant === "sup" && "vertical-align: super;"};
    ${variant === "sub" && "vertical-align: sub;"};
    ${display && `display: ${display};`};
    ${listStyleType && `list-style-type: ${listStyleType};`}; ;
  `}
  ${_styledSystem.space}
${_color.default}
`;
Typography.defaultProps = {
  color: "blackOpacity90",
  variant: "p",
  theme: _base.default
};
Typography.propTypes = {
  /** Styled system spacing props */
  ..._propTypes2.default.space,

  /** Styled system color props */
  ..._propTypes2.default.color,

  /** The visual style to apply to the component */
  variant: _propTypes.default.oneOf(["h1-large", "h1", "h2", "h3", "h4", "h5", "segment-header", "segment-header-small", "segment-subheader", "segment-subheader-alt", "p", "small", "big", "sup", "sub", "strong", "b", "em"]),

  /** Override the variant component */
  as: _propTypes.default.string,

  /** Override the variant font-size */
  fontSize: _propTypes.default.string,

  /** Override the variant font-weight */
  fontWeight: _propTypes.default.string,

  /** Override the variant line-height */
  lineHeight: _propTypes.default.string,

  /** Override the variant text-transform */
  textTransform: _propTypes.default.string,

  /** Override the variant text-decoration */
  textDecoration: _propTypes.default.string,

  /** Override the variant display */
  display: _propTypes.default.string,

  /** Override the list-style-type */
  listStyleType: _propTypes.default.string,

  /** Override the white-space type */
  whiteSpace: _propTypes.default.string,

  /** Override the word-wrap type */
  wordWrap: _propTypes.default.string,

  /** Override the text-overflow type */
  textOverflow: _propTypes.default.string,

  /** Apply truncation */
  truncate: _propTypes.default.bool
};
var _default = Typography;
exports.default = _default;